<template>
  <!-- 勤務カテゴリごとの設定、実績集計値 -->
  <div>
    <table class="summary-table" :class="{ 'summary-table-wide': from_work_count_edit_many }" border="1">
      <thead>
        <tr>
          <th rowspan="2">設定値</th>
          <th v-for="category in workCategories"
            colspan="2" :key="category">
            {{ work_category_summary.settings[category].category_name_jpn }}
          </th>
          <th 
            v-for="workpatternGroup in Object.values(work_category_group_label).map(({ category_name_jpn}) => category_name_jpn)"
            colspan="2"
            :key="workpatternGroup"
          >
            {{ workpatternGroup }}
          </th>
        </tr>
        <tr>
          <template v-for="category in [...workCategories, ...Object.values(work_category_group_label).map(({ category_name_jpn}) => category_name_jpn)]">
            <th v-for="label in ['下限', '上限']" :key="category + label">
              {{ label }}
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td :class="{ 'text-align-left': from_work_count_edit_many }">
            ⑤で入力した日ごとの配置人数
          </td>
          <template v-for="category in [...workCategories, ...Object.keys(work_category_group_label)]">
            <td :key="category + 'min'">{{ staffAssignmentsPerCategory[category].min }}</td>
            <td :key="category + 'max'">{{ staffAssignmentsPerCategory[category].max }}</td>
          </template>
        </tr>
        <tr>
          <td :class="{ 'text-align-left': from_work_count_edit_many }">
            {{ from_work_count_edit_many ? '日ごとの配置人数から計算した月あたりの勤務回数の基準値' : '常時配置人数' }}
          </td>
          <template v-for="category in [...workCategories, ...Object.keys(work_category_group_label)]">
            <td :key="category + 'min'">{{ staffAssignmentsPerCategory[category].monthlyMin }}</td>
            <td :key="category + 'max'">{{ staffAssignmentsPerCategory[category].monthlyMax }}</td>
          </template>
        </tr>
        <tr>
          <td :class="{ 'text-align-left': from_work_count_edit_many }">
            <template v-if="from_work_count_edit_many">
              ⑥で入力した月当たりの勤務回数の合計（詳細は
              <a href="https://support.synchroshift.jp/portal/ja/kb/articles/1042" target="_blank" rel="noopener noreferrer">
                こちら
                <font-awesome-icon icon="external-link-alt" style="font-size: 12px; font-weight: 600; color: #1059CC; vertical-align: text-top;" />
              </a>
              ）
            </template>
            <template v-else>
              勤務回数
            </template>
          </td>
          <template v-for="category in [...workCategories, ...Object.keys(work_category_group_label)]">
            <td :key="category + 'min'" :class="alertClassObject.min[category]">{{ work_category_summary.archievement[category].min || 0 }}</td>
            <td :key="category + 'max'" :class="alertClassObject.max[category]">{{ work_category_summary.archievement[category].max || 0 }}</td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scope>
.work-count-alert {
  background-color: #ff82b4ff !important;
  color: #ffffff;
}
.summary-table {
  table-layout: auto;
  text-align: center;
  min-width: 800px;
  max-width: 100%;
  border-collapse: collapse;
}

/* from_work_count_edit_many = true のときのみ適用される幅広スタイル */
.summary-table-wide {
  min-width: 1200px;
}

.summary-table-wide th {
  min-width: 80px;
  padding: 8px;
}

.summary-table-wide td {
  padding: 8px;
}

.summary-table th {
  font-size: 14px;
  font-weight: 500;
  border: solid 1px rgba(210, 214, 219, 0.5) !important;
  background-color: #f3f4f6;
}

.summary-table td {
  border: solid 1px rgba(210, 214, 219, 0.5) !important;
  text-align: center;
  vertical-align: middle;
}

.text-align-left {
  text-align: left !important;
}
</style>

<script>
export default {
  props: {
    //1チームのカテゴリごとのworkpattern配列
    one_team_workpatterns_by_category: {
      type: Object | Array,
      default: function () {
        return {};
      },
    },
    //常時配置人数の値(staff_assignment)
    assignment: {
      type: Object | Array,
      default: function () {
        return {};
      },
    },
    //スタッフのワークパターン(実績値) [office_staff.id][workpattern.id]
    settings_office_staff_workpatterns: {
      type: Object | Array,
      default: function () {
        return {};
      },
    },
    //office_staffリスト
    settings_office_staffs: {
      type: Object | Array,
      default: function () {
        return {};
      },
    },
    //勤務グループ設定
    office_wp_list_assignment: {
      type: Object | Array,
      default: function () {
        return {};
      },
    },
    //勤務グループのラベル(遅A、遅B) keyはworkpattern_idを-でつないだもの 1-2-4
    work_category_group_label: {
      type: Object | Array,
      default: function () {
        return {};
      },
    },
    //1月の曜日ごとの日数
    week_cnt: {
      type: Object,
      default: function () {
        return {};
      },
    },
    team_id: {
      type: Number,
      default: 0,
    },
    from_work_count_edit_many: {
      type: Boolean,
      default: false,
    },
    staffAssignmentsPerCategory: {
      type: Object,
      default: function () {
        return {};
      },
    },
    workcountSumsPerWorkpattern: {
      type: Object | Array,
      default: function () {
        return {};
      },
    }
  },
  data() {
    return {
      work_category_summary: {
        settings: {},
        archievement: {},
      }, //再計算された常時配置人数と勤務回数
      wp_list_workpattern_id_list: {}, //勤���グループのチームのものだけ keyがwp_list_assignmentと連動
      wp_list_assignment: {}, //勤務グループ設定のチームのものだけ keyがwp_listworkpattern_id_listと連動
      workCategories: ['early', 'day', 'late', 'night', 'dawn'] ,
    };
  },
  mounted() {
    this.calculateWorkCategoryArchivement();
    this.calculateWorkCategorySettings();
    this.calculateWorkCategoryGroupSettings();
  },
  created() {
    this.initialWpListAssignment();
    this.initialSettingsArchivement();
  },
  methods: {
    //常時配置人数を再計算する
    calculateWorkCategorySettings() {
      if (!this.one_team_workpatterns_by_category || !this.assignment) {
        return;
      }

      Object.entries(this.one_team_workpatterns_by_category).forEach(
        ([category, category_workpattern_ids]) => {
          if (category === '') {
            return;
          }
          //カテゴリごとの集計値
          let category_max_count = 0,
            category_min_count = 0;

          Object.values(category_workpattern_ids).forEach((workpattern_id) => {
            let calc_assignment = this.calcAssignment(
              this.assignment[workpattern_id],
              this.week_cnt
            );
            category_max_count += parseInt(calc_assignment.max);
            category_min_count += parseInt(calc_assignment.min);
          });

          //計算結果をセット
          this.work_category_summary.settings[category].max = category_max_count;
          this.work_category_summary.settings[category].min = category_min_count;
        }
      );
    },
    //勤務グループの常時配置人数を再計算する
    calculateWorkCategoryGroupSettings() {
      if (!this.wp_list_assignment) {
        return;
      }

      Object.entries(this.wp_list_assignment).forEach(([key, assignment]) => {
        if (!this.wp_list_workpattern_id_list[key]) {
          return;
        }

        let workpattern_string = this.wp_list_workpattern_id_list[key].join('-');

        let calc_assignment = this.calcAssignment(assignment, this.week_cnt);
        if (this.work_category_summary.settings[workpattern_string]) {
          this.work_category_summary.settings[workpattern_string].max = calc_assignment.max;
          this.work_category_summary.settings[workpattern_string].min = calc_assignment.min;
        }
      });
    },
    //勤務回数の集計
    calculateWorkCategoryArchivement() {
      let countWorkpattern = {};
      
      this.initialSettingsArchivement();
      
      Object.entries(this.workcountSumsPerWorkpattern).forEach(([workpatternId, {
        category,
        max,
        min,
      }]) => {
        // 勤務カテゴリごとの集計
        if (this.work_category_summary.archievement[category]) {
          this.work_category_summary.archievement[category].max += parseInt(max) || 0;
          this.work_category_summary.archievement[category].min += parseInt(min) || 0;
        }

        // 勤務区分ごとの集計
        if (!countWorkpattern[workpatternId]) {
          countWorkpattern[workpatternId] = { min: 0, max: 0 };
        }
        countWorkpattern[workpatternId].max += parseInt(max) || 0;
        countWorkpattern[workpatternId].min += parseInt(min) || 0;
      });

      //グループの集計
      Object.values(this.wp_list_workpattern_id_list).forEach((workpatternIds) => {
        const workpatternString = workpatternIds.join('-');
        
        Object.values(workpatternIds).forEach((workpatternId) => {
          this.work_category_summary.archievement[workpatternString].max += countWorkpattern[workpatternId]?.max || 0;
          this.work_category_summary.archievement[workpatternString].min += countWorkpattern[workpatternId]?.min || 0;
        });
      });

    },
    /**
     * 1か月の常時配置人数の計算
     * assignment 曜日ごとの設定値 {def:{max:2, min:2},mon:{max:2, min:2}}...
     * week_cnt 1月の曜日ごとの日数 {mon:4,tue:4}...
     */
    calcAssignment(assignment, week_cnt) {
      if (assignment === undefined) {
        return { min: 0, max: 0 };
      }

      const def_max = assignment.def.max;
      const def_min = assignment.def.min;
      let max_count = 0,
        min_count = 0;

      Object.entries(assignment).forEach(([day, min_max]) => {
        if (day !== 'def') {
          if (parseInt(assignment[day].max) === 0 && parseInt(assignment[day].min) === 0) {
            max_count += week_cnt[day] * def_max;
            min_count += week_cnt[day] * def_min;
          } else {
            max_count += week_cnt[day] * min_max.max;
            min_count += week_cnt[day] * min_max.min;
          }
        }
      });

      return { min: min_count, max: max_count };
    },
    initialWpListAssignment() {
      // wp_listを初期化する team_idのリストが存在しなければ空
      let initial = this.office_wp_list_assignment;

      if (initial !== null) {
        if (this.team_id in initial) {
          for (let key in initial[this.team_id]) {
            let group = initial[this.team_id][key];
            if (group.workpattern_id_list !== null && group.workpattern_id_list.length > 1) {
              this.$set(this.wp_list_workpattern_id_list, key, group.workpattern_id_list);
              this.$set(this.wp_list_assignment, key, group.staff_assignment);
            }
          }
        }
      }
    },
    //work_category_summary.settings work_category_summary.archivement���初期化する
    initialSettingsArchivement() {
      let settings_archivement = {
        early: { min: 0, max: 0, category_name_jpn: '早番' },
        day: { min: 0, max: 0, category_name_jpn: '日勤' },
        late: { min: 0, max: 0, category_name_jpn: '遅番' },
        night: { min: 0, max: 0, category_name_jpn: '夜勤' },
        dawn: { min: 0, max: 0, category_name_jpn: '明番' },
      };

      //勤務グループの初期設定
      Object.entries(this.wp_list_assignment).forEach(([key, assignment]) => {
        if (!this.wp_list_workpattern_id_list[key]) {
          return;
        }

        let workpattern_string = this.wp_list_workpattern_id_list[key].join('-');
        // 新しい勤務パターングループを追加
        settings_archivement[workpattern_string] = {
          min: 0,
          max: 0,
          category_name_jpn: this.work_category_group_label[workpattern_string]?.category_name_jpn,
        };
      });

      this.work_category_summary.settings = JSON.parse(JSON.stringify(settings_archivement));
      this.work_category_summary.archievement = JSON.parse(JSON.stringify(settings_archivement));
    },
  },
  watch: {
    assignment: {
      handler: 'calculateWorkCategorySettings',
      deep: true,
    },
    wp_list_assignment: {
      handler: 'calculateWorkCategoryGroupSettings',
      deep: true,
    },
    settings_office_staff_workpatterns: {
      handler(new_data) {
        this.calculateWorkCategoryArchivement();
      },
      deep: true,
    },
    workcountSumsPerWorkpattern: {
      handler(new_data) {
        this.calculateWorkCategoryArchivement();
      },
      deep: true,
    },
  },
  computed: {
    alertClassObject() {
      const initialAcc = { min: {}, max: {} };
      return this.workCategories.reduce((acc, category) => {
        acc.min[category] = this.work_category_summary?.archievement?.[category]?.min > this.staffAssignmentsPerCategory?.[category].monthlyMin ? 'work-count-alert' : '';
        acc.max[category] = this.work_category_summary?.archievement?.[category]?.max < this.staffAssignmentsPerCategory?.[category].monthlyMax ? 'work-count-alert' : '';
        return acc;
      }, initialAcc);
    },
  },
};
</script>
